import { useQuery } from '@tanstack/react-query';

import { api } from '../api/api';

const getServerVersion = () => {
  return api.get<{ buildVersion: string }>('./version.json');
};

export function useGetServerVersion(refetchInterval = 5 * 60 * 1000) {
  return useQuery({
    queryFn: () => getServerVersion(),
    queryKey: ['version'],
    refetchInterval,
  });
}
